import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import InstituteWidgetService from "../../../services/KangarooServices/Intelligence/InstituteWidgetService";
import InstituteWidgetForm from "../component/InstituteWidgetForm";
import toast from "react-hot-toast";
import HomeWidgetForm from "../component/HomeWidgetForm";
import HomeWidgetService from "../../../services/KangarooServices/Intelligence/HomeWidgetService";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";
import Select from "react-select";
import noimage from "../../../assets/kangaroo/noimage.png";

const HomeWidget = () => {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const toggleWidget = (item) => {
    setSelectedItem(item);
    setIsWidgetOpen(!isWidgetOpen);
  };
  const authUser = getLoggedInUser();

  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const isOffshoreAdmin = authUser.roles.includes("OffshoreAdmin");

  const isOnshorePage = isOnshoreAdmin ? true : isOffshoreAdmin ? false : null;
  console.log("🚀 ~ HomeWidget ~ isOnshorePage:", isOnshorePage);
  const [filters, setFilters] = useState({
    isOnshore: isOnshorePage,
    widgetPageType: 9, // ✅ add this
  });

  const [debouncedFilters, setDebouncedFilters] = useState(filters);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);
    return () => clearTimeout(timer);
  }, [filters]);

  const getShortText = (html, limit = 100) => {
    if (!html) return "";

    const text = html.replace(/<[^>]*>/g, ""); // remove HTML tags
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };

  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await HomeWidgetService.getList({
        ...debouncedFilters, // ✅ includes widgetPageType automatically
      });

      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [debouncedFilters]);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await HomeWidgetService.delete(selectedDeleteItem.id);
        fetchData();
        toast.success("Widget deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  const widgetTypeData = [
    { value: 1, label: "Home" },
    { value: 2, label: "Test Preparation" },
    { value: 3, label: "Travel" },
    { value: 4, label: "OSHC" },
    { value: 5, label: "Visa & Migration" },
    { value: 6, label: "Tax Return" },
    { value: 7, label: "Kevs Fees and Charges" },
    { value: 8, label: "Education" },
  ];

  const handleTypeChange = (selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      widgetPageType: selectedOption ? selectedOption.value : 9,
    }));
    ``;
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Page Widgets" pageTitle="Widget Setup" />

        <Row className="mb-3">
          <Col xs={7} lg={6} className=" ">
            <div className="d-flex justify-content-between align-items-center ">
              <button className="btn btn-success" onClick={toggleWidget}>
                <i className="bi bi-plus-lg"></i> Add Widget
              </button>
            </div>
          </Col>
          <Col xs={7} lg={6} className=" ">
            <Select
              options={widgetTypeData}
              value={widgetTypeData.find(
                (option) => option.value === filters.widgetPageType,
              )}
              onChange={handleTypeChange}
              placeholder="Select widget page type"
              isClearable
            />
          </Col>
        </Row>

        <Row xs="1" md="2" lg="4" className="g-3">
          {data?.map((item, index) => {
            return (
              <Col key={item.id} lg={4}>
                <Card className="h-100 shadow-sm border-0 rounded-4 small-card">
                  <div className="logo-wrapper">
                    <CardImg
                      top
                      // src={`${imageBaseApi}${item?.widget?.image?.url}`}
                      src={
                        item?.widget?.image?.url
                          ? `${imageBaseApi}${item.widget?.image.url}`
                          : noimage
                      }
                      alt={item.fileName}
                      style={{
                        objectFit: "contain",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                  <CardBody className="py-2 px-3">
                    <span className="text-muted ">{item?.widgetPageType}</span>

                    <p>{item?.widget?.name}</p>
                    <p className="text-muted ">{item?.widget?.headingName}</p>

                    {/* <div>{getShortText(item?.widget?.description, 150)}</div> */}
                  </CardBody>
                  <CardFooter className="bg-transparent border-0 pt-0 pb-3 px-3 d-flex justify-content-between align-content-center align-items-center">
                    <div className="d-flex gap-2">
                      <Button
                        size="sm"
                        color="warning"
                        className="d-flex align-items-center gap-1"
                        onClick={() => toggleWidget(item)}
                      >
                        <i className="ri-edit-line"></i>
                      </Button>
                      <Button
                        size="sm"
                        color="danger"
                        className="d-flex align-items-center gap-1"
                        onClick={() => handleDeleteClick(item)}
                      >
                        <i className="ri-delete-bin-5-line"></i>
                      </Button>
                    </div>
                    <Badge color={item?.isOnshore ? "success" : "danger"}>
                      {item?.isOnshore ? "Onshore" : "Offshore"}
                    </Badge>
                  </CardFooter>
                </Card>
              </Col>
            );
          })}
        </Row>
        <HomeWidgetForm
          isOpen={isWidgetOpen}
          toggle={toggleWidget}
          selectedItem={selectedItem}
          fetchData={fetchData}
        />
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default HomeWidget;
